import { getToken } from "./user-service";

// Sunflower lanyard orders desk (role LANYARD_ORDERS_DESK).
// Every call carries the signed-in user's real Firebase ID token; access is
// enforced server-side (prm-users-mobile requireLanyardDesk).
const base_url = "/api/v1/mobileusers/shop/staff/orders";

// error carrying the HTTP status so the desk can sign out on 401/403
// and show the server message on 400/404/409
const deskError = (status, message) => {
  const error = new Error(message || "Something went wrong, please try again.");
  error.status = status;
  return error;
};

const readJson = async (response) => {
  try {
    return await response.json();
  } catch (e) {
    return null;
  }
};

const request = async (url, options = {}) => {
  let token;
  try {
    token = await getToken();
  } catch (e) {
    // no signed-in user — treat as unauthorised
    throw deskError(401, "Your session has ended. Please log in again.");
  }

  let response;
  try {
    response = await fetch(url, {
      ...options,
      cache: "no-store",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
        "Firebase-UID": token,
      },
    });
  } catch (e) {
    throw deskError(0, "Could not reach the server. Check your connection and try again.");
  }

  const json = await readJson(response);

  if (!response.ok) {
    const message = json && typeof json.message === "string" ? json.message : null;
    throw deskError(response.status, message);
  }

  return json;
};

// GET one page of orders, newest first
// status: 'placed' | 'ready' | 'completed' | 'cancelled' (optional), iata: 'DUB' (optional),
// fulfilment: 'collection' | 'delivery' (optional), q: passenger, email, order id or flight (optional),
// skip / limit: paging (limit max 200)
// -> { orders: LanyardOrder[], total: number }
export const getLanyardOrders = async ({ status, iata, fulfilment, q, skip, limit } = {}) => {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (iata) params.set("iata", iata);
  if (fulfilment) params.set("fulfilment", fulfilment);
  if (q) params.set("q", q);
  if (skip) params.set("skip", String(skip));
  if (limit) params.set("limit", String(limit));

  const query = params.toString();
  const json = await request(base_url + (query ? "?" + query : ""), { method: "GET" });
  const orders = Array.isArray(json?.orders) ? json.orders : [];
  return { orders, total: typeof json?.total === "number" ? json.total : orders.length };
};

// move an order on: 'ready' | 'completed' | 'cancelled'
// -> LanyardOrder
export const updateLanyardOrderStatus = async (id, status) => {
  const json = await request(`${base_url}/${encodeURIComponent(id)}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
  return json?.order || null;
};
